import {Feature} from 'acng/core/model/feature.js';

const name = 'moviePool';
export default name;
export const moviePoolFeature = new Feature(name);
